import axios from "axios";
import { getApiBaseUrl } from "./config";
import { getAuthRequestTokens } from "./auth-service";
import { buildAuthCookieHeader } from "@/lib/auth-cookies";

const ax = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

ax.interceptors.request.use(
  async (config) => {
    const { accessToken, refreshToken } = await getAuthRequestTokens();
    const cookieHeader = buildAuthCookieHeader(
      accessToken ?? undefined,
      refreshToken,
    );

    if (cookieHeader) {
      config.headers["Cookie"] = cookieHeader;
    }

    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    return config;
  },
  async (error) => {
    console.error("Request error:", error.response?.data || error.message);
    return Promise.reject(error);
  },
);

export default ax;
